import Vue from 'vue';
import axios from 'axios';
import ApiService from "../api/api.service";

export default class DocumentHttpService{

    getUser() {
        return axios.get('/api/user').then( function(response) { console.log(response.data); });
    }

    async get(id) {
        ApiService.setHeader();
        return ApiService.get('/api/document/'+id);
    }

    async store(postData) {
        ApiService.setHeader();
        return ApiService.post('/api/document', postData);
    }

    async getAll(teamsOnly) {
        let slug = '';
        if(teamsOnly) {
            slug = '?teams_only=true';
        }
        ApiService.setHeader();
        return ApiService.get('/api/document', slug);
    }

    async getShared(params) {
        ApiService.setHeader();
        return ApiService.post('/api/community-docs', params);
    }

    async delete(id) {
        ApiService.setHeader();
        return ApiService.delete('/api/document/'+id);
    }

    async getFile(url) {
        // ApiService.setHeader();
        
        return ApiService.getFile(url);
    }
}
